var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.243,
    height: 13.243,
    className: "closeIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: "2px"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    d: "m11.121 2.121-9 9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    d: "m2.121 2.121 9 9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ecd12528153a95a13c159d2154c2b12c.svg";
export { ForwardRef as ReactComponent };